import type { ReactNode } from 'react';
import { Grid, useStyles } from '@archipro-design/aria';

import * as S from './PageLayout.style';

interface PageSectionsProps {
    children: ReactNode;
}

const PageSections = ({ children }: PageSectionsProps) => {
    const { css } = useStyles();

    return (
        <Grid columns={`100%`} className={css(S.Sections)}>
            {children}
        </Grid>
    );
};

export default PageSections;
